import { render, staticRenderFns } from "./tableHeaderConfiguration.vue?vue&type=template&id=68bbc5c4"
import script from "./tableHeaderConfiguration.vue?vue&type=script&lang=js"
export * from "./tableHeaderConfiguration.vue?vue&type=script&lang=js"
import style0 from "./tableHeaderConfiguration.vue?vue&type=style&index=0&id=68bbc5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports